import { render, staticRenderFns } from "./finance-profit-report-parentAsin.vue?vue&type=template&id=244e738b&scoped=true&"
import script from "./finance-profit-report-parentAsin.vue?vue&type=script&lang=js&"
export * from "./finance-profit-report-parentAsin.vue?vue&type=script&lang=js&"
import style0 from "./finance-profit-report-parentAsin.vue?vue&type=style&index=0&id=244e738b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244e738b",
  null
  
)

export default component.exports